
import { Vue, Options } from 'vue-class-component'
import { maska } from 'maska'
import { Prop, Watch } from 'vue-property-decorator'
import { IFlexMessageBox, IFlexMessageURIAction } from '@/utils/types'
import Offset from '@/components/common/flex-message/forms/Offset.vue'
import Padding from '@/components/common/flex-message/forms/Padding.vue'
import Action from '@/components/common/flex-message/forms/Action.vue'
import Background from '@/components/common/flex-message/forms/Background.vue'

@Options({
  components: { Background, Action, Padding, Offset },
  directives: { maska },
  emits: ['update:modelValue', 'update:validateValue'],
})
export default class Box extends Vue {
  @Prop()
  modelValue!: IFlexMessageBox

  get value() {
    return this.modelValue
  }

  set value(value: IFlexMessageBox) {
    this.$emit('update:modelValue', value)
  }

  get typeList() {
    return [
      {
        label: 'ボックス',
        value: 'box',
      },
    ]
  }

  get spacingMarginList() {
    return ['none', 'xs', 'sm', 'md', 'lg', 'xl', 'xxl']
  }

  get borderList() {
    return ['none', 'light', 'normal', 'medium', 'semi-bold', 'bold']
  }

  widthHeightValidate(val) {
    if (!val) return true
    return /^(\d+(\.\d+)?)(px|%)$/.test(val)
  }

  colorValidate(val) {
    if (!val) return true
    return /^#[0-9A-Fa-f]{6}([0-9A-Fa-f]{2})?$/.test(val)
  }

  spacingMarginValidate(val) {
    if (!val) return true

    const isPx = /^\d+(\.\d+)?px$/.test(val)
    const isKeyword = this.spacingMarginList.includes(val)
    return !(!isPx && !isKeyword)
  }

  borderValidate(val) {
    if (!val) return true

    const isPx = /^\d+(\.\d+)?px$/.test(val)
    const isKeyword = this.borderList.includes(val)
    return !(!isPx && !isKeyword)
  }

  @Watch('value', { deep: true })
  async validate() {
    await this.$nextTick(async () => {
      const isValid = await this.$refs.formRef.validate()
      if (isValid) {
        this.$emit('update:validateValue', true)
      } else {
        this.$emit('update:validateValue', false)
      }
      return isValid
    })
  }

  mounted() {
    if (this.value.action) {
      if (this.value.action.type === 'uri') {
        const uriAction: IFlexMessageURIAction = {
          type: 'uri',
          label: 'action',
          uri: 'http://linecorp.com/',
          altUri: {
            desktop: '',
          },
        }
        this.value.action = { ...uriAction, ...this.value.action }
      }
    }
    this.validate()
  }
}
